// LPPortal.jsx — standalone /portal shell. The portal is a maximised window:
// it fills the viewport above the fixed bottom taskbar and (unlike desktop
// windows) can't be minimised.
import React, { useEffect } from 'react';
import LimitedPartnerPortal from '../../components/lp/LimitedPartnerPortal';
import PageTaskbar from '../../components/ui/Taskbar/PageTaskbar';
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../firebaseConfig";
import { setShareMeta } from '../../helpers/shareMeta';
import '../../styles/App.css';

export default function LPPortal() {
  // Force window scroll to top on mount. The portal interior uses position:fixed
  // so this is normally a no-op, but child effects (e.g. scrollIntoView) can
  // bubble to the document and leave the page scrolled.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Route-specific link-preview card for shares of /portal.
  useEffect(() => setShareMeta({
    image: "https://www.goodneighbor.fund/assets/og/lp-portal.png",
    url: "https://www.goodneighbor.fund/portal",
  }), []);

  // Full-screen wrapper for the LP Portal
  const handleOpenGNFWebsite = () => {
    window.location.href = '/';
  };

  // Store auth state for desktop navigation
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        sessionStorage.setItem('lpPortalAuthenticated', 'true');
      } else {
        sessionStorage.removeItem('lpPortalAuthenticated');
      }
    });
    return unsubscribe;
  }, []);

  return (
    <div style={{
      height: '100dvh',
      width: '100%',
      margin: 0,
      padding: 0,
      overflow: 'hidden'
    }}>
      {/* Portal fills the space above the taskbar — always maximised.
          --taskbar-h tracks the bar's real height, safe-area inset included. */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 'var(--taskbar-h, 34px)',
        overflow: 'hidden'
      }}>
        <LimitedPartnerPortal
          onOpenGNFWebsite={handleOpenGNFWebsite}
          isStandalone={true}
        />
      </div>

      <PageTaskbar windowLabel="LP portal" windowIcon="portal" />
    </div>
  );
}
